import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import DefaultPicture from '../../components/01_atoms/DefaultPicture';
import FormattedText from '../../components/01_atoms/FormattedText';
import ProductPrice from '../ProductPrice';
import { isCustomPrice } from '../../utils/Gifts/products';
import AddCustomDonationForm from './AddCustomDonationForm';
import { DEFAULT_CURRENCY } from '../../utils/currency';
import RemoveProductButton from '../RemoveProductButton';

import styles from './index.module.scss';

const CustomDonationWidget = ({ mode = 'basket' }) => {
  const donationProducts = Object.values(useSelector((state) => state.productsStorage['donation']));
  const currentDonation = useSelector((state) =>
    state.basket.products.find((product) => isCustomPrice(product.data)),
  );

  if (!donationProducts.length) {
    return null;
  }

  const donationProduct = donationProducts.find(
    (product) => product.price[DEFAULT_CURRENCY].sku === mode,
  );
  if (!donationProduct) {
    return null;
  }

  // // const { formData } = this.state;
  // if (mode === 'cards' && currentDonation && !formData.amount) {
  //   // Hide if custom donation already exists.
  //   return null;
  // }
  //
  // if (currentDonation && currentDonation.data && currentDonation.data.price && !formData.amount) {
  //   // If custom donation already exists, set it as default value.
  //   formData.amount = currentDonation.data.price.amount;
  // }

  return (
    <div data-component="custom-donation-widget">
      <div
        className={`${styles['custom-donation-widget']} ${styles['custom-donation-widget__desktop']} ${styles[`custom-donation-widget--${mode}`]} ${
          currentDonation ? styles['custom-donation-widget--donation-added'] : ''
        }`}
      >
        <div className={styles['custom-donation-widget__row']}>
          <span className={styles['custom-donation-widget__thumb']}>
            <DefaultPicture {...donationProduct.image} />
          </span>

          <div className={styles['custom-donation-widget__details']}>
            <h3 className={styles['custom-donation-widget__title']}>{donationProduct.title}</h3>
            <FormattedText
              className={styles['custom-donation-widget__description']}
              text={donationProduct.annotation}
            />

            <div className={styles['custom-donation-widget__footer']}>
              <AddCustomDonationForm
                product={donationProduct}
                existingCustomPriceProduct={currentDonation}
              />

              {currentDonation && <RemoveProductButton productId={currentDonation.id} />}
            </div>
          </div>
          {currentDonation && (
            <h4 className={styles['custom-donation-widget__price']}>
              <ProductPrice product={currentDonation.data} />
            </h4>
          )}
        </div>
      </div>
      <div
        className={`${styles['custom-donation-widget']} ${styles['custom-donation-widget__mobile']} ${styles[`custom-donation-widget--${mode}`]} ${
          currentDonation ? styles['custom-donation-widget--donation-added'] : ''
        }`}
      >
        <div className={styles['custom-donation-widget__header']}>
          <h3 className={styles['custom-donation-widget__title']}>{donationProduct.title}</h3>

          {currentDonation && (
            <h4 className={styles['custom-donation-widget__price']}>
              <ProductPrice product={currentDonation.data} />
            </h4>
          )}
        </div>
        <div className={styles['custom-donation-widget__row']}>
          <span className={styles['custom-donation-widget__thumb']}>
            <DefaultPicture {...donationProduct.image} />
          </span>
          <FormattedText
            className={styles['custom-donation-widget__description']}
            text={donationProduct.annotation}
          />
        </div>
        <div className={styles['custom-donation-widget__footer']}>
          <AddCustomDonationForm
            product={donationProduct}
            existingCustomPriceProduct={currentDonation}
          />

          {currentDonation && <RemoveProductButton productId={currentDonation.id} />}
        </div>
      </div>
    </div>
  );
};

CustomDonationWidget.propTypes = {
  mode: PropTypes.oneOf(['basket', 'empty-basket', 'cards']),
};

export default CustomDonationWidget;
